import styled from 'styled-components';
import { Layout } from '@/ui';
import { COLORS, pickThemeFontStyles } from '@/theme';

export const StyledLayout = styled(Layout)`
  background: ${COLORS.GRAY_LIGHT};
  padding: 0 !important;

  &.ant-layout {
    min-height: 100vh;
    min-width: 15.3rem;
    padding: 3rem 0 0 0;
    border-right: 0.1rem solid ${COLORS.LIGHT_GRAY};
    background: ${COLORS.GRAY_LIGHT};
  }
`;

export const StyledLogoWrap = styled.div`
  min-width: 5.5rem;
  display: flex;
  gap: 0.5rem;
  margin: 0 0 2rem;
  align-items: center;
  justify-content: center;
`;

export const StyledTitle = styled.p`
  ${pickThemeFontStyles('20', '30', 'BOLD')};
  color: ${COLORS.BLACK_PRIMARY};
  margin: 0;
`;

export const StyledLogo = styled.img`
  width: 1.8rem;
  height: 1.8rem;
`;

export const StyledLinkWrap = styled.div`
  position: absolute;
  bottom: 4rem;
  left: 1.3rem;
`;

export const StyledA = styled.a`
  display: flex;
  gap: 0.425rem;
`;

export const StylesLogoOut = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 1.3rem;
  color: ${COLORS.RED};
  cursor: pointer;
`;

export const StyledTitleModal = styled.p`
  ${pickThemeFontStyles('20', '24', 'SEMI_BOLD')};
  margin-bottom: 2rem;
`;

export const StyledButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;

  &&& {
    button {
      ${pickThemeFontStyles('14', '22', 'BOLD')};
      width: 100%;
    }
  }
`;
